import React from "react";
import { Link, useLocation } from "react-router-dom";

function AdminSidebar() {
  const location = useLocation();

  const menu = [
    { name: "Dashboard", path: "/admin/dashboard", icon: "📊" },
    { name: "Farmers", path: "/admin/farmers", icon: "👨‍🌾" },
    { name: "Cycles", path: "/admin/cycles", icon: "♻️" },
    { name: "Checklist", path: "/admin/checklists", icon: "✅" },
    { name: "Photos", path: "/admin/photos", icon: "📷" },
    { name: "AI Recommendations", path: "/admin/recommendations", icon: "🤖" },
    { name: "Planner", path: "/admin/planner", icon: "📅" },
    { name: "Weather", path: "/admin/weather", icon: "🌦️" },
    { name: "Support", path: "/admin/support", icon: "🛠️" },
    { name: "Settings", path: "/admin/settings", icon: "⚙️" }
  ];

  return (
    <div
      style={{
        width: "260px",
        minHeight: "100vh",
        background: "#1b5e20",
        color: "#fff",
        padding: "20px"
      }}
    >
      <h3 className="fw-bold mb-4">🌱 SURAJ AI Admin</h3>

      {menu.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          style={{
            display: "block",
            padding: "12px",
            marginBottom: "8px",
            borderRadius: "10px",
            textDecoration: "none",
            color: "#fff",
            background:
              location.pathname === item.path
                ? "#43a047"
                : "transparent"
          }}
        >
          {item.icon} {item.name}
        </Link>
      ))}
    </div>
  );
}

export default AdminSidebar;